import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchUkPublicHolidays = createAsyncThunk(
  'publicHolidays/fetchUkPublicHolidays',
  async ({ years }, { signal, rejectWithValue }) => {
    try {
      const yearList = Array.isArray(years) ? years : [];
      const results = await Promise.all(
        yearList.map(async (year) => {
          const res = await fetch(`https://date.nager.at/api/v3/PublicHolidays/${year}/GB`, { signal });
          if (!res.ok) return [];
          const json = await res.json().catch(() => []);
          return Array.isArray(json) ? json : [];
        })
      );
      const all = results.flat();
      const dates = all.map((h) => h?.date).filter(Boolean);
      return Array.from(new Set(dates)); // dedupe
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('publicHolidays/fetchUkPublicHolidays failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch public holidays');
    }
  }
);

const slice = createSlice({
  name: 'publicHolidays',
  initialState: { dates: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUkPublicHolidays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUkPublicHolidays.fulfilled, (state, action) => {
        state.loading = false;
        state.dates = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchUkPublicHolidays.rejected, (state, action) => {
        state.loading = false;
        if (action?.meta?.aborted || action?.error?.name === 'AbortError') return;
        state.error = action.payload || action.error?.message || 'Failed to fetch public holidays';
      });
  },
});

export default slice.reducer;


